import reduce from 'lodash/reduce';
import has from 'lodash/has';

import {
  GET_PUBLIC_DATASETS_SUCCESS,
  GET_PUBLIC_DATASETS_FAILURE,
  GET_PUBLIC_DATASETS_SUMMARY_SUCCESS,
  GET_PUBLIC_DATASETS_SUMMARY_FAILURE,
  GET_PUBLIC_DATASET_SUCCESS,
  GET_PUBLIC_DATASET_SUMMARY_SUCCESS,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';

const initialState = {
  lastUpdated: null,
  byId: [],
  summaryById: {},
  error: null,
};

export const publicDatasetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PUBLIC_DATASETS_SUCCESS:
      return savePublicDatasets(state, action);

    case GET_PUBLIC_DATASET_SUCCESS:
      return savePublicDataset(state, action);

    case GET_PUBLIC_DATASETS_FAILURE:
      return removeDatasets(state, action);

    case GET_PUBLIC_DATASETS_SUMMARY_SUCCESS:
      return saveDatasetsSummary(state, action);
    case GET_PUBLIC_DATASET_SUMMARY_SUCCESS:
      return saveDatasetSummary(state, action);

    case GET_PUBLIC_DATASETS_SUMMARY_FAILURE:
      return {
        ...state,
        summaryById: {},
      };

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

// export const sharedDatasetsReducer;

function savePublicDatasets(state, action) {
  let { result, receivedAt } = action;

  return {
    ...state,
    byId: result,
    lastUpdated: receivedAt,
    error: null,
  };
}

function savePublicDataset(state, action) {
  const { result, receivedAt } = action;
  //TODO: sorting might get screwed up here!
  if (result) {
    return {
      ...state,
      byId: [result, ...state.byId],
      lastUpdated: receivedAt,
      error: null,
    };
  }

  return state;
}

function removeDatasets(state, action) {
  return {
    ...initialState,
    lastUpdated: action.receivedAt,
    error: action.error,
  };
}

function saveDatasetsSummary(state, action) {
  let summaryById = reduce(
    action.result,
    (result, v) => {
      result[v.id] = v.summary;
      return result;
    },
    {},
  );

  return { ...state, summaryById };
}

function saveDatasetSummary(state, action) {
  const { result } = action;
  let { summaryById } = state;
  if (has(result, 'id')) {
    summaryById = { ...summaryById, [result.id]: result };
    return { ...state, summaryById };
  } else {
    return state;
  }
}
